const selectors = {
  reviews: 'data-reviews',
};

class ProductGridReviews {
  constructor(section) {
    this.container = section.container;
    this.showReviews = this.container.getAttribute(selectors.reviews) !== 'false';
    this.reviewsAppInstalled = typeof window.SPR === 'function';

    this.init();
  }

  init() {
    if (this.showReviews && typeof yotpo !== 'undefined') {
      yotpo.initialized ? yotpo.refreshWidgets() : yotpo.initWidgets();
    } else if (this.showReviews && this.reviewsAppInstalled) {
      window.SPR.initDomEls();
      window.SPR.loadBadges();
    }
  }
}
const productGridReviews = {
  onLoad() {
    new ProductGridReviews(this);
  },
};

export default productGridReviews;
